/**
 * convert pathname to Capitalized letter of every word,
 * replace "-" instead of white spaces, spit by "/"
 * returns requied name of the tab
 * (current part of pathname in which we located at the momment)
 * except of number
 *  @param pathname
 * @returns string
 */
export const convertPathToTabName = pathname => {
  function capitalLetter(str) {
    str = str.replace(/[-]/g, ' ').split(' ')

    for (var i = 0, x = str.length; i < x; i++) {
      str[i] = str[i][0].toUpperCase() + str[i].substr(1)
    }

    return str.join(' ')
  }
  const paths = pathname.split('/')
  const rawTabName = paths[paths.length - 1]

  const formattedTabName =
    isNaN(rawTabName) === true
      ? paths[paths.length - 1]
      : paths[paths.length - 2]
  const stageName = getStageName(process.env.REACT_APP_NODE_ENV)
  return capitalLetter(`${stageName} | ${formattedTabName}`)
}

/**
 *changing current tab name with formated and converted tab name
 * @param pathname
 * @returns string
 */
export const updateTabName = (pathname, notifications) => {
  const tabName = convertPathToTabName(pathname)
  setTabName(`${tabName} ${notifications ? `(${notifications})` : ''}`)
}

export const setTabName = tabName => {
  document.title = tabName
}

const getStageName = envName => {
  if (envName === 'prod') {
    return 'Promofy'
  }
  return envName
}

export const getCampaignIdFromPath = pathname => {
  const regex = /campaigns\/(\d+)/
  const match = pathname.match(regex)
  return match ? match[1] : null
}
